import { ApplicationRef, EnvironmentProviders, inject, provideEnvironmentInitializer, Provider, DOCUMENT } from '@angular/core';
import { ModalContainerComponent } from './components/modal-container.component';

import { ComponentPortal, DomPortalOutlet } from '@angular/cdk/portal';

export function provideModals(): Array<EnvironmentProviders | Provider> {
  return [
    provideEnvironmentInitializer(() => {
      const document = inject(DOCUMENT);
      const appRef = inject(ApplicationRef);
      const outlet = new DomPortalOutlet(document.body, appRef)

      const portal = new ComponentPortal(ModalContainerComponent);
      outlet.attach(portal);
    })
  ]
}
